// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {

  constructor() {
    super();
    this.stickyAddToCart = this.querySelector('[data-sticky-add-to-cart]');

    this.productFormWrapper = this.querySelector('.product__form');
    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');

    this.productServices = Array.from(this.querySelectorAll('[data-product-service]'));

    this.popup = this.querySelector('[data-product-services-popup]');
    this.popupShadow = this.querySelector('[data-product-services-popup-shadow]');
    this.popupWrapper = this.querySelector('[data-product-services-popup-wrapper]');
    this.popupClose = this.querySelector('[data-product-services-popup-close]');

    this.popupClose?.addEventListener('click', () => this.close());
    this.popupShadow?.addEventListener('click', () => this.close());

    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    })

    this.stickyAddToCartButton();
    this.productServicesPopup();

  }

  stickyAddToCartButton() {
    let productFormScrollTop = this.productFormWrapper.getBoundingClientRect().top;

    const headerHeight = document.querySelector('.header__top').clientHeight;
    const stickyAddToCartHeight = this.stickyAddToCart.clientHeight - 6;

    const addToCartHeight = this.productFormWrapper.clientHeight;

    const lowerVisibilityPoint = headerHeight - addToCartHeight;
    const upperVisibilityPoint = screen.height - headerHeight - stickyAddToCartHeight + addToCartHeight;

    document.addEventListener('scroll', () => {
      productFormScrollTop = this.productForm.getBoundingClientRect().top;

      this.stickyAddToCart.dataset.headerHeight = `${headerHeight}px`;
      this.stickyAddToCart.style.setProperty('--header-height', `${headerHeight}px`);

      if (productFormScrollTop > lowerVisibilityPoint && productFormScrollTop <= upperVisibilityPoint) {
        this.stickyAddToCart.classList.remove('sticky-add-to-cart');
      }
      else {
        this.stickyAddToCart.classList.add('sticky-add-to-cart');
      }
    });
  }

  // close the popup
  close() {
    this.popup.classList.remove('active', 'animate');
  }

  productServicesPopup() {
    const that = this;

    this.productServices.map((productService) => {

      productService.querySelector('[data-product-service-trigger]')?.addEventListener('click', function() {
        const productServiceDescription = productService.dataset.productServiceDescription;
        if (productServiceDescription != '' && productServiceDescription != ' ') {
          that.popup.classList.add('active', 'animate');
          that.popupWrapper.textContent = productService.dataset.productServiceDescription;
        }
      });

    })
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}
